// extracted by css-extract-rspack-plugin
export default {"SpinnerContainer":"CenteredLoadingSpinner-module__SpinnerContainer__Ofjw0"};